module.exports = __webpack_public_path__ + "html/section-video-sign-up_64f95369f2eafa6c4152fd462a8c0829.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-video-sign-up.html
// module id = WUbV
// module chunks = 54